// extracted by mini-css-extract-plugin
export var phone = "_42-0";